import { EuiButton, EuiCallOut, EuiTextColor } from "@elastic/eui";
import React, { useState } from "react";

import { FormattedMessage } from "react-intl";
import TripSection from "../../shared/TripSection";

import { AddDropOffsModal } from "../../shared/AddDropOffsModal";
import * as S from "../../../style";
import DropoffAccordion from "./DropoffAccordion";

const renderUpdateDropoffsBtn = (color, onClick) => (
    <EuiButton
        color={color}
        onClick={onClick}
    >
        <FormattedMessage id="trip.edit-dropoff-action" />
    </EuiButton>
);

export default function TripDropoff({
    pickupPoint,
    tripDropoffs,
    attachments,
    tripId,
    canAppendPoints,
    isFieldsEditable,
    onDropoffsChange,
    onDropOffFieldChange,
    onDropoffDelete,
    organizationId,
    alwaysEditableFields,
}) {
    const [isModalVisible, setIsModalVisible] = useState(false);

    // canModify on any point indicates that all points can't be edited
    const canModifyPoints = !!tripDropoffs[0]?.canModify;
    const canChangePoints = canModifyPoints || canAppendPoints;

    const closeModal = () => setIsModalVisible(false);
    const showModal = () => setIsModalVisible(true);

    const saveDropoffs = (dropOffs) => {
        onDropoffsChange(dropOffs);
        closeModal();
    };

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.dropoff-details-section-title" />}
            headerIconType="menuRight"
            isIconSection
        >
            <S.TripDropOffWrapper>
                {!tripDropoffs.length ? (
                    <EuiCallOut
                        title="Warning! "
                        color="warning"
                        iconType="alert"
                    >
                        <p>
                            <EuiTextColor color="warning">
                                <FormattedMessage id="trip.dropoff-missing" />
                                {canChangePoints && (
                                    <FormattedMessage id="trip.prompt-txt-dropoff-missing" />
                                )}
                            </EuiTextColor>
                        </p>
                        {canChangePoints && renderUpdateDropoffsBtn("warning", showModal)}
                    </EuiCallOut>
                ) : (
                    <>
                        <DropoffAccordion
                            tripDropoffs={tripDropoffs}
                            attachments={attachments}
                            isDropoffFieldsEditable={isFieldsEditable}
                            onDropOffFieldChange={onDropOffFieldChange}
                            alwaysEditableFields={alwaysEditableFields}
                        />
                        {canChangePoints && renderUpdateDropoffsBtn("secondary", showModal)}
                    </>
                )}
                {isModalVisible && (
                    <AddDropOffsModal
                        tripId={tripId}
                        pickupPoint={pickupPoint}
                        saveDropoffs={saveDropoffs}
                        closeModal={closeModal}
                        defaultValue={tripDropoffs}
                        onDropoffDelete={onDropoffDelete}
                        canAppend={canAppendPoints}
                        canModify={canModifyPoints}
                        organizationId={organizationId}
                    />
                )}
            </S.TripDropOffWrapper>
        </TripSection>
    );
}
